export default __webpack_public_path__ + "static/media/Ankle_Pain.9dc406bf.webp";